<span
	(click)="showCarrierContactDetails(); $event.stopPropagation()"
	*ngIf="!showButton"
	style="cursor: pointer; color: #4682b4"
	>{{ text }}</span
>

<button
	(click)="showCarrierContactDetails(); $event.stopPropagation()"
	*ngIf="showButton"
	color="primary"
	mat-raised-button
>
	{{ text }}
</button>
